import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LookupDto } from 'src/app/core/models/shared/LookupDto';
import { UserProfileLookups } from 'src/app/core/models/user-profile/user-profile.model';
import { BaseComponent } from 'src/app/shared/base/BaseComponent';
import { InputPatterns } from 'src/app/shared/input-components/validators/InputPatterns';
import { lessThanDate } from 'src/app/shared/input-components/validators/more-than-date.validator';

@Component({
  selector: 'app-profile-person-info',
  templateUrl: 'profile-person-info.component.html',
})
export class ProfilePersonInfoComponent
  extends BaseComponent
  implements OnInit
{
  @Input() isVerified: boolean;
  @Input() lookups: UserProfileLookups;
  @Input() form: FormGroup;
  formTemp: any;
  @Input() isRegistered: boolean = false;

  ngOnInit(): void {
    this.form.addControl(
      'NameAr',
      new FormControl(null, [
        Validators.required,
        Validators.pattern(InputPatterns.NonNumbericEnglishOrArabic),
      ])
    );
    this.form.addControl(
      'NameEn',
      new FormControl(null, [
        Validators.required,
        Validators.pattern(InputPatterns.NonNumbericEnglish),
      ])
    );
    this.form.addControl(
      'ResidencyType',
      new FormControl(null, [Validators.required])
    );
    this.form.addControl(
      'Nationality',
      new FormControl(null, [Validators.required])
    );

    this.form.addControl(
      'IdNumber',
      new FormControl(null, [Validators.required])
    );

    this.form.addControl(
      'Passport',
      new FormControl(null, [
        Validators.required,
        Validators.pattern(InputPatterns.AlphaNumeric),
      ])
    );

    this.form.addControl(
      'Gender',
      new FormControl(null, [Validators.required])
    );
    this.form.addControl(
      'HasDisability',
      new FormControl(null, [Validators.required])
    );
    this.form.addControl('Disabilities', new FormControl(null));
    if (this.isRegistered) {
      this.form.addControl(
        'BirthDate',
        new FormControl(null, [Validators.required, lessThanDate(new Date())])
      );
      this.form.addControl('Job', new FormControl(null, [Validators.required]));
      this.form.addControl(
        'MaritalStatus',
        new FormControl(null, [Validators.required])
      );
      this.form.addControl(
        'FamilyMembersNumber',
        new FormControl(null, [Validators.required])
      );
      this.form.addControl(
        'TotalIncome',
        new FormControl(null, [Validators.required])
      );
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['lookups']) {
      this.formTemp = { ...this.form.value };
      if (this.form?.controls?.ResidencyType?.value?.code != 'Other') {
        this.form?.controls?.IdNumber?.enable();
        this.form?.controls?.Passport?.disable();
      } else {
        this.form?.controls?.IdNumber?.disable();
        this.form?.controls?.Passport?.enable();
      }
    }
  }

  onHasDisabilityChange() {
    if (this.form.controls.HasDisability.value) {
      this.form.controls?.Disabilities.addValidators(Validators.required);
    } else {
      this.form.controls?.Disabilities.removeValidators(Validators.required);
    }
    this.form.controls?.Disabilities.updateValueAndValidity();
  }
}
